var finansudd = finansudd || {};

finansudd.filter = new function(){

    var self = this;


    this.toggleDropdown = function () {
    	var $selector = $('.filter-trigger, .filter-wrapper > label');

		$selector.click(function() {
			var $thisParent = $(this).parents('.filter-wrapper'),
				$wrappers = $('.filter-wrapper');
				
			$wrappers.not($thisParent).removeClass('active-filter');	
			$thisParent.toggleClass('active-filter');
			$('body').hasClass('transparent-overlay') ? $('body').removeClass('transparent-overlay') : $('body').addClass('transparent-overlay');
		});


		finansudd.overlay.removeActive('.filter-wrapper', 'active-filter');

	};

    this.toggleMobileFilter = function () {

		$('.mobile-filter').click(function() {
			$('body').addClass('open-overlay');
			$('.mobile-holder').toggleClass('open');
		});

		finansudd.overlay.removeActive('.mobile-holder', 'open');

	};

	this.resetFilters = function () {

		var $trigger = $('.trigger.reset'),
			$filter = $('.filter-wrapper');

		$trigger.click(function() {

			$filter.each(function() {
				var $this = $(this),
					$parentSelect = $this.find('.select');

				// Close the filter-wrapper
				$this.removeClass('active-filter');
								
				// Check if its a multiple select
				if(!$parentSelect.hasClass('multiple')) {
					// Add selected class to the data value with 0
					$this.find('.select li[data-value="0"]').addClass('selected');
					// Reset the select-box and add change-event
					$this.find('select option[value="0"]').prop('selected', true).change();
				}
				else
				{
					// Reset the select-box and add change-event
					$this.find('select option').prop('selected', false).change();
				}

			});
		});

	};

};